var emptyFocus = {
  store: null,
  options: null
};
var initialState = {
  focus: [{
    store: 'cellSets',
    options: {
      keys: ['louvain']
    }
  }],
  groupedTrack: 'louvain',
  selectedTracks: ['louvain']
};
export default initialState;
export { emptyFocus };